var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/images/network_logo_minicity.png';
const _withScopeId = n => (_pushScopeId("data-v-ad62b0e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "box taskDetailPanel pt-3 pb-3 pl-5 pr-5"
};
const _hoisted_2 = { class: "media" };
const _hoisted_3 = { class: "media-content" };
const _hoisted_4 = { class: "content" };
const _hoisted_5 = { class: "level is-mobile" };
const _hoisted_6 = { class: "buttonRow level-left" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-history mr-2" }, null, -1));
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check-square mr-2" }, null, -1));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-check-square mr-2" }, null, -1));
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-ban mr-2" }, null, -1));
const _hoisted_11 = { class: "tag is-light is-rounded has-text-weight-bold ml-1" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt mr-2" }, null, -1));
const _hoisted_13 = { class: "level is-mobile mt-2" };
const _hoisted_14 = { class: "level-left" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", { class: "mr-2" }, "Created By:", -1));
const _hoisted_16 = { key: 1 };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    class: "networkLogo mr-1",
    src: _imports_0
}, null, -1));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "tag is-info is-light is-rounded has-text-weight-bold ml-1" }, "Automated Task", -1));
const _hoisted_19 = { class: "level-right" };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("hr", null, null, -1));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle mb-4" }, "History", -1));
const _hoisted_23 = { class: "columns is-mobile mb-1" };
const _hoisted_24 = { class: "column" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock mr-2" }, null, -1));
const _hoisted_26 = { key: 0 };
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { key: 2 };
const _hoisted_29 = {
    key: 0,
    class: "notification bulmaNotification is-danger"
};
import { doApiAction } from "@/core/api";
import { CONFIG } from "@/core/config";
import { taskStatusLabels, TaskStatus, isEntityManagedByMe } from "@/core/model";
import { enumKey, formatDateTime, formatTime12Hour, formatTimeDifference, fromPreferredTimezoneToUTC, timestampToYYYYMMDD } from "@/core/utils";
import { computed, onMounted, reactive, ref } from "vue";
import { apiTasks } from "./api";
import { isNetworkAdmin } from "@/core/session";
import ModalDialog from "@/components/ModalDialog.vue";
import { Core } from "@minicity/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TaskDetailPanel',
    props: {
        task: {},
        highlighted: { type: Boolean },
        showEntityLink: { type: Boolean }
    },
    emits: ['taskUpdated'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        // We need to copy the task prop, as we cannot mutate props
        const taskCopy = ref(null);
        onMounted(() => {
            taskCopy.value = Object.assign({}, props.task);
        });
        const datePrompt = reactive({
            status: null,
            date: "",
            time: "",
            error: "",
        });
        const showDatePrompt = (status) => {
            datePrompt.status = status;
            datePrompt.date = timestampToYYYYMMDD(Date.now().valueOf());
            datePrompt.time = formatTime12Hour(Date.now().valueOf());
            datePrompt.error = "";
        };
        const applyStatusChange = () => {
            const utc = fromPreferredTimezoneToUTC(`${datePrompt.date} ${datePrompt.time}`, "YYYY-MM-DD hh:mm A");
            if (isNaN(utc)) {
                datePrompt.error = "Not a valid date / time";
                return;
            }
            switch (datePrompt.status) {
                case TaskStatus.COMPLETED:
                    markTaskAsCompleted(new Date(utc));
                    break;
                case TaskStatus.CANCELLED:
                    cancelTask(new Date(utc));
                    break;
            }
        };
        const entityLink = computed(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            switch ((_a = taskCopy.value) === null || _a === void 0 ? void 0 : _a.entityType) {
                case Core.EntityType['Citizen']: return `/citizens/${(_b = taskCopy.value) === null || _b === void 0 ? void 0 : _b.entityId}`;
                case Core.EntityType['Birth Record']: return `/birthRecords/${(_c = taskCopy.value) === null || _c === void 0 ? void 0 : _c.entityId}`;
                case Core.EntityType['Georgia DFCS Benefits']: return `/georgiaBenefits/${(_d = taskCopy.value) === null || _d === void 0 ? void 0 : _d.entityId}`;
                case Core.EntityType['Social Security']: return `/socialSecurity/${(_e = taskCopy.value) === null || _e === void 0 ? void 0 : _e.entityId}`;
                case Core.EntityType['Partner']: return `/partners/${(_f = taskCopy.value) === null || _f === void 0 ? void 0 : _f.entityId}`;
                case Core.EntityType['Partner User']: return `/partnerUsers/${(_g = taskCopy.value) === null || _g === void 0 ? void 0 : _g.entityId}`;
                case Core.EntityType['Partner Site']: return `/sites/${(_h = taskCopy.value) === null || _h === void 0 ? void 0 : _h.entityId}`;
                default: return null;
            }
        });
        // Event for two-way binding
        const emit = __emit;
        const onTaskChanged = () => {
            emit('taskUpdated', taskCopy.value);
        };
        const inProgressAction = ref(null);
        const onStatusChange = (newStatus) => {
            taskCopy.value.status = newStatus;
            taskCopy.value.statusHistory.push({ toStatus: newStatus, occurredAt: new Date().getTime() });
            onTaskChanged();
            datePrompt.status = null;
        };
        const notRequiredLabel = computed(() => {
            var _a;
            switch ((_a = taskCopy.value) === null || _a === void 0 ? void 0 : _a.taskType) {
                case "LIFT_2_0_BIRTH_RECORD_ORDER":
                case "LIFT_2_0_SOCIAL_SECURITY_ORDER":
                case "LIFT_2_0_STATE_ID_ORDER":
                case "LIFT_2_0_TB_TESTING":
                    return "Skip - Document On Hand";
                default:
                    return "Mark As Not Required";
            }
        });
        const markTaskAsCompleted = (d) => {
            doApiAction(inProgressAction, 'markTaskAsCompleted', "Marked task as complete", "Failed to mark task as complete", () => apiTasks.markCompleted(taskCopy.value.id, d).then(() => {
                onStatusChange(TaskStatus.COMPLETED);
            }));
        };
        const cancelTask = (d) => {
            doApiAction(inProgressAction, 'cancelTask', "Cancelled task", "Failed to cancel task", () => apiTasks.cancel(taskCopy.value.id, d).then(() => {
                onStatusChange(TaskStatus.CANCELLED);
            }));
        };
        const submitTaskForReview = () => {
            doApiAction(inProgressAction, 'submiTaskForReview', "Submitted task for review", "Failed to submit task for review", () => apiTasks.submitForReview(taskCopy.value.id).then(() => {
                onStatusChange(TaskStatus.REVIEW_REQUIRED);
            }));
        };
        const reopenTask = () => {
            doApiAction(inProgressAction, 'reopenTask', "Re-opened task", "Failed to re-open task", () => apiTasks.reopen(taskCopy.value.id).then(() => {
                onStatusChange(TaskStatus.OPEN);
            }));
        };
        const addComment = (message, attachments, notifyCaseworker) => __awaiter(this, void 0, void 0, function* () {
            const comment = yield apiTasks.addComment(taskCopy.value.id, message, attachments, notifyCaseworker);
            ++taskCopy.value.commentCount;
            onTaskChanged();
            return comment;
        });
        return (_ctx, _cache) => {
            var _a;
            const _component_router_link = _resolveComponent("router-link");
            const _component_UserBadge = _resolveComponent("UserBadge");
            const _component_CommentSection = _resolveComponent("CommentSection");
            const _component_FormDateField = _resolveComponent("FormDateField");
            const _component_FormTextField = _resolveComponent("FormTextField");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (taskCopy.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("article", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                (_ctx.task.status != _unref(TaskStatus).OPEN)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'reopenTask' }, 'mb-2']]),
                                                        onClick: _cache[0] || (_cache[0] = ($event) => (reopenTask()))
                                                    }, [
                                                        _hoisted_7,
                                                        _createTextVNode("Re-Open Task")
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (!_unref(isEntityManagedByMe)(_ctx.task.entityType) && _ctx.task.status == _unref(TaskStatus).OPEN)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'submiTaskForReview' }, 'mb-2']]),
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (submitTaskForReview()))
                                                    }, [
                                                        _hoisted_8,
                                                        _createTextVNode("Submit For Review")
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (_unref(isEntityManagedByMe)(_ctx.task.entityType) && _ctx.task.status == _unref(TaskStatus).OPEN)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 2,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'markTaskAsCompleted' }, 'mb-2']]),
                                                        onClick: _cache[2] || (_cache[2] = ($event) => (_unref(isNetworkAdmin)() ? showDatePrompt(_unref(TaskStatus).COMPLETED) : markTaskAsCompleted(new Date())))
                                                    }, [
                                                        _hoisted_9,
                                                        _createTextVNode("Mark As Completed")
                                                    ], 2))
                                                    : _createCommentVNode("", true),
                                                (_unref(isEntityManagedByMe)(_ctx.task.entityType) && _ctx.task.status == _unref(TaskStatus).OPEN)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 3,
                                                        type: "submit",
                                                        class: _normalizeClass(["formButton button is-info is-small", [{ 'is-loading': inProgressAction.value == 'cancelTask' }, 'mb-2']]),
                                                        onClick: _cache[3] || (_cache[3] = ($event) => (_unref(isNetworkAdmin)() ? showDatePrompt(_unref(TaskStatus).CANCELLED) : cancelTask(new Date())))
                                                    }, [
                                                        _hoisted_10,
                                                        _createTextVNode(_toDisplayString(notRequiredLabel.value), 1)
                                                    ], 2))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            (_ctx.showEntityLink && entityLink.value)
                                                ? (_openBlock(), _createBlock(_component_router_link, {
                                                    key: 0,
                                                    to: `${entityLink.value}?taskId=${taskCopy.value.id}`,
                                                    target: "_blank",
                                                    class: "level-right"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("span", _hoisted_11, [
                                                            _hoisted_12,
                                                            _createTextVNode(" View " + _toDisplayString(_unref(enumKey)(taskCopy.value.entityType, _unref(Core).EntityType)) + " Page ", 1)
                                                        ])
                                                    ]),
                                                    _: 1
                                                }, 8, ["to"]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("nav", _hoisted_13, [
                                            _createElementVNode("small", _hoisted_14, [
                                                _hoisted_15,
                                                ((_a = taskCopy.value.author) === null || _a === void 0 ? void 0 : _a.id)
                                                    ? (_openBlock(), _createBlock(_component_UserBadge, {
                                                        key: 0,
                                                        user: taskCopy.value.author
                                                    }, null, 8, ["user"]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                        _hoisted_17,
                                                        _createElementVNode("strong", null, _toDisplayString(_unref(CONFIG).networkName), 1),
                                                        _hoisted_18
                                                    ]))
                                            ]),
                                            _createElementVNode("small", _hoisted_19, [
                                                _createElementVNode("strong", null, _toDisplayString(_unref(formatDateTime)(taskCopy.value.createdAt)), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("p", null, _toDisplayString(taskCopy.value.message), 1)
                                        ]),
                                        _hoisted_20,
                                        _createVNode(_component_CommentSection, {
                                            getComments: () => _unref(apiTasks).getComments(taskCopy.value.id),
                                            addComment: addComment,
                                            getAttachmentViewLink: (commentId, attachmentId) => _unref(apiTasks).getCommentAttachmentViewLink(taskCopy.value.id, commentId, attachmentId)
                                        }, null, 8, ["getComments", "getAttachmentViewLink"]),
                                        _hoisted_21,
                                        _hoisted_22,
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.statusHistory, (statusChange, idx) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: idx,
                                                        style: { "font-size": "75%" }
                                                    }, [
                                                        _hoisted_25,
                                                        (idx == 0)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Created with status "))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_27, "Status changed to ")),
                                                        _createElementVNode("strong", null, _toDisplayString(_unref(taskStatusLabels)[statusChange.toStatus]), 1),
                                                        _createTextVNode(" at " + _toDisplayString(_unref(formatDateTime)(statusChange.occurredAt)) + " ", 1),
                                                        (idx < _ctx.task.statusHistory.length - 1)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, " (remained in this status for " + _toDisplayString(_unref(formatTimeDifference)(_ctx.task.statusHistory[idx].occurredAt, _ctx.task.statusHistory[idx + 1].occurredAt)) + ")", 1))
                                                            : _createCommentVNode("", true)
                                                    ]));
                                                }), 128))
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (datePrompt.status)
                    ? (_openBlock(), _createBlock(ModalDialog, {
                        key: 1,
                        active: datePrompt.status != null,
                        title: "Specify Date",
                        severity: "link",
                        allowClose: true,
                        onClose: _cache[6] || (_cache[6] = ($event) => (datePrompt.status = null)),
                        firstButtonText: "Go Back",
                        firstButtonSeverity: "link",
                        onFirstbuttonselected: _cache[7] || (_cache[7] = ($event) => (datePrompt.status = null)),
                        secondButtonText: `Mark As ${_unref(taskStatusLabels)[datePrompt.status]}`,
                        secondButtonSeverity: "success",
                        onSecondbuttonselected: _cache[8] || (_cache[8] = ($event) => (applyStatusChange()))
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_FormDateField, {
                                modelValue: datePrompt.date,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((datePrompt.date) = $event)),
                                label: "Select Date",
                                past: ""
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FormTextField, {
                                modelValue: datePrompt.time,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((datePrompt.time) = $event)),
                                label: "Select Time"
                            }, null, 8, ["modelValue"]),
                            (datePrompt.error != '')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(datePrompt.error), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }, 8, ["active", "secondButtonText"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
